import {
  CAlert,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CFormInput,
  CLoadingButton,
  CRow,
} from '@coreui/react-pro'

import React, { useState } from 'react'
import ToastComponent from 'src/components/common/TaostComponent'
import RoundService from 'src/service/RoundService'
import SampleRoundCSV from '../../assets/SampleRoundFile.csv'

const ImportRound = () => {
  const [file, setFile] = useState()
  const [array, setArray] = useState([])
  const [errorMessages, setErrorMessages] = useState([])

  const fileReader = new FileReader()

  const handleOnChange = (e) => {
    setFile(e.target.files[0])
  }

  const csvFileToArray = (string) => {
    const csvHeader = string.slice(0, string.indexOf('\n')).split(',')
    const csvRows = string.slice(string.indexOf('\n') + 1).split('\n')

    const arr = csvRows
      .filter((i) => i.trim() !== '')
      .map((i) => {
        const values = i.split(',')
        const obj = csvHeader.reduce((object, header, index) => {
          object[header] = values[index]?.trim()
          return object
        }, {})
        return obj
      })

    setArray(arr)
  }

  const handleImportRound = () => {
    if (!file) {
      ToastComponent('Please upload a CSV file.', 'error')
      return
    }

    fileReader.onload = function (event) {
      const text = event.target.result
      csvFileToArray(text)
    }

    fileReader.readAsText(file)
  }

  // When CSV rows loaded
  React.useEffect(() => {
    if (array.length === 0) return

    const payload = { roundData: array }

    RoundService.importRound(payload).then((res) => {
      if (res.success) {
        if (res.errors.length > 0) {
          setErrorMessages(res.errors)
        } else {
          ToastComponent(res?.message, 'success')
          setErrorMessages([])
        }
      } else if (!res.success && res.errors.length > 0) {
        setErrorMessages(res.errors)
      } else {
        setErrorMessages(['Import failed. Please check your CSV.'])
      }
    })
  }, [array])

  return (
    <>
      {errorMessages.length > 0 && (
        <div className="error-list">
          {errorMessages.map((error, index) => (
            <CAlert color="danger" key={index}>
              {error}
            </CAlert>
          ))}
        </div>
      )}

      <CRow className="pt-2">
        <CCol xs={12}>
          <CCard>
            <CCardHeader>
              <strong>Import Rounds</strong>
            </CCardHeader>

            <CCardBody>
              <CRow>
                <CCol md={6}>
                  <CFormInput type="file" accept={'.csv'} onChange={handleOnChange} />
                </CCol>

                <CCol md={6}>
                  <CLoadingButton color="success" variant="outline" onClick={handleImportRound}>
                    Run Import
                  </CLoadingButton>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>

        <CCol xs={12}>
          <CCard className="mt-3">
            <CCardHeader>
              <strong>Download Sample File</strong>
            </CCardHeader>

            <CCardBody>
              <p>Please use the CSV format provided below to import rounds into the system.</p>

              <a href={SampleRoundCSV} download="Round-Sample-CSV.csv">
                <CButton color="primary" variant="outline">
                  Download Sample CSV
                </CButton>
              </a>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </>
  )
}

export default ImportRound
